import Protected from "@/pages/protected";
import { DataService } from "@/services/data";
import { PaginatedResponse } from "@/types/common";
import { CallType } from "@/types/voice/call";
import { Outlet, RouteObject } from "react-router-dom";
import ArchiveCallRoute from "./archive";
import PicklistsRoute from "./picklists";
import { handle_error } from "@/utils/wretch";

const CallsRoute: RouteObject = {
    path: "appels",
    element: (
        <Protected groups={["app_voice_admin", "team_adv", "team_support"]}>
            <Outlet />
        </Protected>
    ),

    children: [
        {
            index: true,
            loader: async ({ request }) => {
                const url = new URL(request.url);
                const calls = (await DataService.client
                    .url(`/voice/calls/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                    .get()
                    .json()) as PaginatedResponse<CallType>;
                return { calls };
            },
            async lazy() {
                let { CallsListPage: CallsListPage } = await import("@/pages/calls/list");
                return { Component: CallsListPage };
            }
        },
        {
            path: "batch",
            action: async ({ request }) => {
                const data = await request.json();
                const url = new URL(request.url);
                const action = url.searchParams.get("action");
                if (action) {
                    try {
                        const content = await DataService.client
                            .url(`/voice/calls/${action}/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                            .post(data)
                            .json();
                        return { success: true, content: content };
                    } catch (error) {
                        return handle_error(error);
                    }
                } else {
                    try {
                        const content = await DataService.client.url(`/voice/calls/`).patch(data).json();
                        return { success: true, content: content };
                    } catch (error) {
                        return handle_error(error);
                    }
                }
            }
        },
        {
            path: ":call_id",
            loader: async ({ params }) => {
                const call = await DataService.client.url(`/voice/calls/${params.call_id}/`).get().json();
                const transcription = await DataService.client.url(`/voice/calls/${params.call_id}/transcription/`).get().json();
                const analytics = await DataService.client.url(`/voice/calls/${params.call_id}/analytics/`).get().json();
                const related_objects = await DataService.client.url(`/voice/calls/${params.call_id}/related_objects/`).get().json();
                return { call, transcription, analytics, related_objects };
            },
            async lazy() {
                let { CallDetailPage } = await import("@/pages/calls/detail");
                return { Component: CallDetailPage };
            },
            action: async ({ params, request }) => {
                const call_id = params.call_id;
                const data = await request.json();
                const url = new URL(request.url);
                const action = url.searchParams.get("action");
                if (action) {
                    try {
                        const content = await DataService.client.url(`/voice/calls/${call_id}/${action}/`).post(data).json();
                        return { success: true, content: content };
                    } catch (error) {
                        return handle_error(error);
                    }
                } else {
                    try {
                        const content = await DataService.client.url(`/voice/calls/${call_id}/`).patch(data).json();
                        return { success: true, content: content };
                    } catch (error) {
                        return handle_error(error);
                    }
                }
            }
        },
        ArchiveCallRoute,
        PicklistsRoute
    ]
};

export default CallsRoute;
